export const getPendingReducer = state => {
  state.isLoading = true;
};

export const getRejectedReducer = state => {
  state.isLoading = false;
};

export const getFreeProxyFulfilledReducer = (state, action) => {
  state.isLoading = false;
  state.freeProxies = action.payload?.proxies;
  state.cities = action.payload?.cities;

  state.isProxyLoaded = true;
};

export const getPaginationDataFulfilledReducer = (state, action) => {
  state.paginationData = action.payload;
};

export const openDropDownReducer = (state, action) => {
  state.isOpenDropDown = action.payload;
};

export const clearSelectedCountryReducer = (state, action) => {
  state.clearSelectedCountry = action.payload;
};

export const exportFreeProxiesFulfilledReducer = (state, action) => {
  state.freeProxiesForExport = action.payload;

  state.isFreeProxiesForExportLoaded = true;
};

export const toFirstRenderFalseFulfilledReducer = state => {
  state.isFirstRender = false;
};
